import React from 'react'
import "./footer.css"


function Footer() {
  

  return (
    <>
      <div className="footer">
      Copyright &copy; Amazon Clone (Asif), All right reserved.
      </div>
    </>
  )
}

export default Footer